Vendd.Scripts.load(function () {

	var $wrapper = $('.x-warehouse-selector-popup');

	if ($wrapper.length < 1) {
		return;
	}

	var wrapper = $wrapper.get(0),
		$root,
		$steps,
		$backButton,
		$closeButton;

	var state = {
		currentStep: undefined
	};

	wrapper.init = function () {
		$root = $('.warehouse-selector-popup', $wrapper);
		$steps = $('.warehouse-selector-step', $root);
		$backButton = $('.js-back', $root);
		$closeButton = $('.js-close', $root);

		Vendd.MessageBus.publish(wrapper, new Vendd.Widget.Messages.BindControl('x-warehouse-selector-popup'));

		state.currentStep = 0;

		wrapper.updateViewState();
	};

	wrapper.updateViewState = function () {
		$steps.removeClass('active').eq(state.currentStep).addClass('active');
		$backButton.toggle(state.currentStep > 0);
		$closeButton.toggle(true);
	};

	wrapper.update = function (model) {
		/* console.log('[WarehouseSelector] Popup JSON model: ' + JSON.stringify(model)); */
		var html = Vendd.Handlebars.parse("warehouseSelectorPopup_A", model);
		$wrapper.html(html);
		wrapper.init();
	};

	wrapper.loading = function (status) {
		if (status === undefined) {
			return $wrapper.hasClass('x-loading');
		} else {
			$wrapper.toggleClass('x-loading', status);
		}
	};

	wrapper.switchToStep = function (value) {
		if (value !== state.currentStep) {
			/* console.log('[WarehouseSelector] Current step: "' + state.currentStep + '" -> "' + value + '"'); */
			state.currentStep = value;
			wrapper.updateViewState();
		}
	};

	wrapper.onShowing = function () {
		wrapper.init();
		wrapper.loading(true);
		Vendd.MessageBus.publishAsync(wrapper, new Vendd.WarehouseSelector.Messages.GetPopupModel());
		Vendd.MessageBus.publish(wrapper, new Vendd.WarehouseSelector.Messages.StateChanged('opening'));
	};

	wrapper.onShown = function () {
		Vendd.MessageBus.publish(wrapper, new Vendd.WarehouseSelector.Messages.StateChanged('opened'));
	};

	wrapper.onHiding = function () {
		Vendd.MessageBus.publish(wrapper, new Vendd.WarehouseSelector.Messages.StateChanged('closing'));
	};

	wrapper.onHidden = function () {
		Vendd.MessageBus.publish(wrapper, new Vendd.WarehouseSelector.Messages.StateChanged('closed'));
	};

	$wrapper.on('click', '.js-back', function (e) {
		e.preventDefault();
		wrapper.switchToStep(Math.max(0, state.currentStep - 1));
	});

	$wrapper.on('click', '.js-close', function (e) {
		e.preventDefault();
		$.fancybox.close();
	});

	Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetPopupModelSuccess, 'x-warehouse-selector-popup', function (envelope) {
		wrapper.loading(false);
		wrapper.update(envelope.message.data.data);
	});

	Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetPopupModelFailed, wrapper, function (envelope) {
		wrapper.loading(false);
	});

	Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.OpenPopup, wrapper, function (envelope) {
		$.fancybox.open($wrapper, {
			modal: true,
			beforeShow: wrapper.onShowing,
			afterShow: wrapper.onShown,
			beforeClose: wrapper.onHiding,
			afterClose: wrapper.onHidden
		});
	});

	Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.ClosePopup, wrapper, function (envelope) {
		$.fancybox.close();
	});

	Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetStoresSuccess, wrapper, function () {
		wrapper.switchToStep(1);
	});

	Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.GetStoresFailed, wrapper, function () {
		wrapper.switchToStep(0);
	});

	Vendd.MessageBus.subscribe(Vendd.WarehouseSelector.Messages.SetShippingMethodSuccess, wrapper, function (envelope) {
		$.fancybox.close();
	});

	/* jQuery extension used by contained components */
	$.fn.extend({
		toggleDisabled: function (value) {
			return this
				.prop('disabled', value)
				.toggleClass('disabled', value)
				.toggleClass('x-disabled', value)
				;
		},
		selectedVal: function (value) {
			if (value === undefined) {
				if (this.is('[type="radio"]')) {
					return this.filter(':checked').val();
				} else {
					return this.val();
				}
			} else {
				if (this.is('[type="radio"]')) {
					return this.filter('[value="' + value + '"]').prop('checked', true);
				} else {
					return this.val(value);
				}
			}
		}
	});
});
